import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { PiPlayFill } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";

import {
  MdOutlineCurrencyRupee,
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import NoImage from "../../assets/images/noImage.jpg";
import { LogEvent } from "../../utils/firebase";
import { GrClose } from "react-icons/gr";
import { IconButton } from "@material-ui/core";
import Modal from "react-modal";
import homeActions from "../../Redux/Home/action";
import { headertitle } from "../helper";

const BlogPage = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { homeTestimonials } = useSelector(
    (state) => state.AuthReducer
  );
  const { currentLanguage } = useSelector((state) => state.commonReducer);
  let [testimonials, setTestimonials] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: homeActions.GET_HOME_CONTENTS,
      payload: {
        language_code: currentLanguage,
        type: headertitle.TESTIMONIAL,
      },
    });
  }, [currentLanguage]);




  useEffect(() => {
    if (homeTestimonials?.length > 0) {

      const filteredTestimonials = homeTestimonials?.filter((item) =>
        item.language?.some(
          (lang) => lang.language_code === currentLanguage
        )
      ).sort(
        (a, b) =>
          new Date(b.created_at).getTime() -
          new Date(a.created_at).getTime()
      ).slice(0, 10);;
      setTestimonials(filteredTestimonials);
    } else {
      setTestimonials([]);
    }
  }, [homeTestimonials, currentLanguage]);



  const openModal = (video) => {
    LogEvent("Home_Testimonials_PlayVideo");
    setSelectedVideo(video);
    setModalIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleViewMore = () => {
    LogEvent("Home_Blog_ViewAll");
    navigate("/blog");
  };

  const closeModal = () => {
    setSelectedVideo(null);
    setModalIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    prevArrow: <MdOutlineArrowBackIos />,
    nextArrow: <MdOutlineArrowForwardIos />,
  };


  function findName(blog) {

    return blog?.language?.find(val => val.
      language_code === currentLanguage)?.title || blog?.title
  }

  function findPlace(blog) {

    return blog?.language?.find(val => val.
      language_code === currentLanguage)?.contents[0]?.place || blog?.language?.find(val => val.
        language_code === "en")?.contents[0]?.place
  }

  return (
    <div
      className="container-fluid farm-equipments"
      style={{ backgroundColor: "#ffff" }}
    >
      <div className="container">
        <div className="home_page_heading_div_cls d-flex justify-content-between">
          {t("Testimonials")}

        </div>
        <div className="mt-3 ">
          {testimonials?.length > 0 ? (
            <Slider

              {...settings}
              className="slider-arrow-custom-style-for-related-products testimonial-slider"
            >
              {testimonials?.map((blog) => (
                <div className="testimonial-card container" key={blog.id}>
                  <div className="row">
                    <div className="col-6 image-container">
                      <img src={blog?.img_url} alt="" className="img-fluid" />
                    </div>
                    <div className="col-6 text-container">
                      <p className="testimonial-description">
                        {formatDescription(blog, currentLanguage)}
                      </p>

                      <div style={{ alignItems: "center", lineHeight: "1.2" }}>
                        {" "}
                        <div style={{ marginRight: "10px" }}>
                          <h2
                            style={{
                              fontSize: "16px",
                              color: "#dc7f92",
                              margin: "0",
                            }}
                          >

                            {findName(blog)}

                          </h2>
                          <p>
                            {findPlace(blog)}
                          </p>
                        </div>
                        <button
                          className="watch-video-btn"
                          onClick={() =>
                            openModal({
                              title: blog?.finalLanguage?.title ?? blog?.title,
                              City:
                                blog?.finalLanguage?.contents[0]?.place ??
                                blog?.language[0]?.contents[0]?.place,
                              youtube_video_id: blog?.youtube_video_id,
                            })
                          }
                        >
                          {t("Watch Video")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="h5 my-3 text-center">{t("No Data Found")}</div>
          )}
        </div>
        <Modal
          ariaHideApp={false}
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          style={{
            overlay: {
              backgroundColor: "rgba(0,0,0,0.8)",
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)",
              zIndex: 1000,
            },
            content: {
              width: "80vw",
              height: "80vh",
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -50%)",
              borderRadius: "10px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            },
          }}
        >
          {selectedVideo && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Close Button */}
              <IconButton
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  zIndex: 10,
                }}
                onClick={closeModal}
              >
                <GrClose />
              </IconButton>


              <h5>
                {selectedVideo.title} ,
                <span className="text-black">{selectedVideo.City}</span>
              </h5>


              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
                  }}
                >
                  <iframe
                    title={selectedVideo.title}
                    src={`https://www.youtube.com/embed/${selectedVideo.youtube_video_id}?enablejsapi=1`}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};
const formatDescription = (testimonial, currentLanguage) => {


  const words = testimonial?.language?.find(val => val.
    language_code === currentLanguage)?.contents[0]?.descirption.split(" ") || [];

  const maxWords = 30;

  const maxLines = 30;
  const lines = [];

  for (let i = 0, wordCount = 0, lineCount = 0; i < words.length; i++) {
    if (
      wordCount + words[i].split("\n").length > maxWords ||
      lineCount >= maxLines
    ) {
      break;
    }

    lines.push(words[i]);
    wordCount += words[i].split("\n").length;
    lineCount += 1;
  }

  return `"${lines.join(" ")}"`;
};

export default BlogPage;
